<template>
  <div class="department-picker">
    <div class="department-select" tabindex="0" @focus="onFocus">
      <div v-if="value.length <= 0" class="placeholder">{{ placeholder }}</div>
      <div v-else-if="multi" class="tags">
        <span
          v-for="(item, index) in value" :key="index"
          class="tag" @mousedown.stop.prevent
        >
          <span>{{ item.name }}</span>
          <i @click="removeSelectedItem(item)" class="mdg-icon dialog_ico_close_blackx"></i>
        </span>
      </div>
      <div v-else class="single-select-text">
        {{ value[0].name }}
      </div>
    </div>
    <el-dialog
      :visible.sync="popupShown" :title="title" class="department-picker-popup"
      width="728px" :close-on-click-modal="false" append-to-body
    >
      <div class="dialog-body">
        <div class="select-box">
          <div class="title">选择</div>
          <div class="mt-10 mb-15">
            <el-input
              v-model="pendingKeyword" placeholder="请输入关键字搜索"
              @keyup.enter.native="searchPendingItems" class="search-box"
            >
              <i slot="suffix" class="mdg-icon ico_search_grayx" @click="searchPendingItems"></i>
            </el-input>
          </div>
          <div class="items-container">
            <div v-if="departments.length <= 0" class="text-center text-placeholder">暂无数据</div>
            <el-tree
              v-else ref="tree" :data="departments" empty-text="暂无数据"
              node-key="id" default-expand-all show-checkbox check-strictly
              :props="{disabled: _selectDisabled}" class="department-tree"
              @check-change="changeSelectedItems" :filter-node-method="treeFilterNodeMethod"
            >
              <div slot-scope="{data}" class="tree-node">
                <i class="mdg-icon ico_xiangmux vcenter"></i>
                <span class="node-name vcenter">{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
        </div>
        <div class="select-box">
          <div class="title">已选</div>
          <div class="mt-10 mb-15">
            <el-input
              v-model="selectedKeyword" placeholder="请输入关键字搜索"
              @keyup.enter.native="searchSelectedItems" class="search-box"
            >
              <i slot="suffix" class="mdg-icon ico_search_grayx" @click="searchSelectedItems"></i>
            </el-input>
          </div>
          <div class="items-container">
            <div v-if="shownSelectedItems.length <= 0" class="text-center text-placeholder">
              暂无数据
            </div>
            <div
              v-else v-for="(item, index) in shownSelectedItems"
              :key="index" class="selected-item"
            >
              <div>
                <i class="mdg-icon ico_xiangmux vcenter"></i>
                <span class="vcenter">{{ item.name }}</span>
              </div>
              <i
                @click="removeShownSelectedItem(item)"
                class="mdg-icon dialog_ico_close_blackx"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="submitPopup" type="primary" size="small" class="action-btn">
          确定
        </el-button>
        <el-button @click="cancelPopup" type="default" size="small" class="action-btn">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog, Button, Input, Tree,
} from 'element-ui'

export default {
  name: 'department-picker',
  props: {
    value: {
      type: Array,
    },
    departments: {
      type: Array,
    },
    title: {
      type: String,
      default: '部门选择',
    },
    placeholder: {
      type: String,
      default: '请选择部门',
    },
    selectDisabled: {
      type: Function,
    },
    multi: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ElDialog: Dialog,
    ElButton: Button,
    ElInput: Input,
    ElTree: Tree,
  },
  data() {
    return {
      popupShown: false,
      pendingKeyword: '',
      selectedKeyword: '',
      selectedItems: [],
      shownSelectedItems: [],
    }
  },
  computed: {
    _selectDisabled() {
      return this.selectDisabled || (() => false)
    },
  },
  methods: {
    onFocus() {
      this.pendingKeyword = ''
      this.selectedKeyword = ''
      this.popupShown = true

      this.$nextTick(() => {
        this.$refs.tree.getCheckedKeys().forEach(
          id => this.$refs.tree.setChecked(id, false, false),
        )
        this.selectedItems = []
        this.shownSelectedItems = []
        this.searchPendingItems()
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.value.map(item => item.id))
          this.searchSelectedItems()
        })
      })
    },
    removeSelectedItem(item) {
      const value = this.value.filter(o => o.id !== item.id)
      this.$emit('input', value)
      this.dispatch('ElFormItem', 'el.form.change', [value])
    },
    submitPopup() {
      this.$emit('input', this.selectedItems)
      this.dispatch('ElFormItem', 'el.form.change', [this.selectedItems])
      this.popupShown = false
    },
    cancelPopup() {
      this.popupShown = false
    },
    treeFilterNodeMethod(keyword, data) {
      return keyword ? data.name.indexOf(keyword) >= 0 : true
    },
    searchPendingItems() {
      this.$refs.tree.filter(this.pendingKeyword)
    },
    searchSelectedItems() {
      this.shownSelectedItems = this.selectedItems.filter(
        item => item.name.indexOf(this.selectedKeyword) >= 0,
      )
    },
    changeSelectedItems(data, checked) {
      if (this.multi) {
        if (checked) {
          this.selectedItems.push(data)
        } else {
          for (let i = 0; i < this.selectedItems.length; i += 1) {
            if (this.selectedItems[i].id === data.id) {
              this.selectedItems.splice(i, 1)
            }
          }
        }
      } else {
        if (checked) {
          this.$refs.tree.getCheckedKeys().forEach((id) => {
            if (id !== data.id) {
              this.$refs.tree.setChecked(id, false, false)
            }
          })
        }
        this.selectedItems = this.$refs.tree.getCheckedNodes()
      }
      this.selectedKeyword = ''
      this.searchSelectedItems()
    },
    removeShownSelectedItem(item) {
      this.$refs.tree.setChecked(item.id, false, false)
      for (let i = 0; i < this.selectedItems.length; i += 1) {
        if (this.selectedItems[i].id === item.id) {
          this.selectedItems.splice(i, 1)
          break
        }
      }
      const keyword = this.selectedKeyword
      this.$nextTick(() => {
        this.selectedKeyword = keyword
        this.searchSelectedItems()
      })
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root
      let name = parent.$options.componentName

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item.is-error .department-select {
  border-color: #FA5C5C !important;
}
.department-select {
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border-radius: 2px;
  border: 1px solid #d3d9e2;
  box-sizing: border-box;
  color: #131d2d;
  display: inline-block;
  font-size: inherit;
  outline: none;
  padding: 5px 6px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:hover {
    border-color: #c0c4cc;
  }
  &:focus {
    outline: none;
    border-color: #6f83a1;
  }
  .placeholder {
    line-height: 26px;
    color: #bbb;
    padding-left: 11px;
  }
  .single-select-text {
    line-height: 26px;
    color: #131d2d;
    padding-left: 11px;
  }
}
.tags {
  display: flex;
  min-height: 26px;
  .tag {
    display: flex;
    align-items: center;
    margin-right: 5px;
    padding: 4px 8px;
    border-radius: 2px;
    background: #ecf4fe;
    font-size: 12px;
    color: #131d2d;
    line-height: 17px;
    .mdg-icon {
      margin-left: 8px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
.dialog-body {
  display: flex;
  justify-content: space-between;
  padding: 32px 32px 26px;
}
.dialog-footer {
  padding-bottom: 24px;
  text-align: center;
  .action-btn {
    width: 106px;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
}
.select-box {
  box-sizing: border-box;
  padding: 12px 12px 0;
  width: 322px;
  background: #f5f7f9;
  .title {
    font-size: 16px;
    color: #3581fb;
    line-height: 22px;
  }
}
.search-box {
  .el-input__inner {
    padding-right: 35px !important;
  }
  .mdg-icon {
    margin: 0 5px;
    font-size: 20px;
    line-height: 36px;
    cursor: pointer;
  }
}
.items-container {
  height: 328px;
  overflow: auto;
}
.department-tree {
  background: transparent;
}
.tree-node {
  margin-left: -3px;
  &.is-leaf .el-checkbox {
    display: none;
  }
  .mdg-icon {
    font-size: 20px;
    color: #a3b4cc;
  }
  .node-name {
    color: #131d2d;
    margin-left: 2px;
  }
}
.selected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  color: #131d2d;
  .mdg-icon {
    margin-right: 4px;
    font-size: 20px;
    color: #a3b4cc;
  }
  .mdg-icon.dialog_ico_close_blackx {
    font-size: 16px;
    color: #131d2d;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.department-picker-popup {
  .search-box {
    .el-input__inner {
      padding-right: 35px !important;
      &:focus {
        border-color: #6f83a1 !important;
      }
    }

  }
  .el-input__icon.el-input__validateIcon {
    display: none;
  }
  .department-tree {
    .el-tree-node__content {
      padding: 4px 0;
    }
    .el-checkbox.is-disabled {
      display: none;
    }
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #131d2d !important;
  }
}
</style>
